import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './staking-stub.module.scss';

const StakingStub = ({ type, icon, text }) => (
  <div className={cn(styles.container, styles[type])}>
    <div className={styles.body}>
      <img className={styles.icon} src={icon} alt='' />
      <div className={styles.text}>{text}</div>
    </div>
  </div>
);

StakingStub.propTypes = {
  type: PropTypes.string,
  icon: PropTypes.string,
  text: PropTypes.string,
};

StakingStub.defaultProps = {
  type: '',
  icon: '',
  text: '',
};

export default StakingStub;
